// import history from "../history";

// import notGithubVariables from './notGithubVariables';

import axios from "axios";
import { api } from "../api";
import { isSuccess } from "../api/httpStatus";
import { getTaxonData } from "../components/biblio/topic_entity_tag/TaxonUtils";

// const port = 11223;
// const port = 49161;

const sgdApiBaseUrl = process.env.REACT_APP_SGD_API_BASE_URL;
const wbApiBaseUrl = process.env.REACT_APP_WB_API_BASE_URL;

export const changeFieldReferenceJson = (e) => {
  console.log('action change field reference json ' + e.target.id + ' to ' + e.target.value);
  return {
    type: 'CHANGE_FIELD_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      value: e.target.value
    }
  };
};

export const changeFieldArrayReferenceJson = (e) => {
  console.log('action change field array reference json ' + e.target.id + ' to ' + e.target.value);
//   console.log(e);
  return {
    type: 'CHANGE_FIELD_ARRAY_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      value: e.target.value
    }
  };
};

export const deleteFieldModReferenceReferenceJson = (e) => {
  console.log('action delete field mod reference json ' + e.target.id + ' to delete');
//   console.log(e);
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'DELETE_FIELD_MOD_REFERENCE_REFERENCE_JSON',
    payload: {
      field: activeElement.id
    }
  };
};

export const changeFieldModReferenceReferenceJson = (e) => {
  console.log('action change field mod reference json ' + e.target.id + ' to ' + e.target.value);
//   console.log(e);
  return {
    type: 'CHANGE_FIELD_MOD_REFERENCE_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      value: e.target.value
    }
  };
};

export const deleteFieldCrossReferencesReferenceJson = (e) => {
  console.log('action delete field cross references json ' + e.target.id + ' to delete');
//   console.log(e);
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'DELETE_FIELD_CROSS_REFERENCES_REFERENCE_JSON',
    payload: {
      field: activeElement.id
    }
  };
};

export const changeFieldCrossReferencesReferenceJson = (e) => {
  console.log('action change field cross references json ' + e.target.id + ' to ' + e.target.value + ' checked ' + e.target.checked);
//   console.log(e);
  return {
    type: 'CHANGE_FIELD_CROSS_REFERENCES_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    }
  };
};

export const deleteFieldModAssociationReferenceJson = (e) => {
  console.log('action delete field mod association json ' + e.target.id + ' to delete');
//   console.log(e);
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'DELETE_FIELD_MOD_ASSOCIATION_REFERENCE_JSON',
    payload: {
      field: activeElement.id
    }
  };
};

export const changeFieldModAssociationReferenceJson = (e) => {
  console.log('action change field mod association json ' + e.target.id + ' to ' + e.target.value + ' checked ' + e.target.checked);
//   console.log(e);
  return {
    type: 'CHANGE_FIELD_MOD_ASSOCIATION_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    }
  };
};


export const changeFieldReferenceRelationsJson = (e) => {
  console.log('action change field reference relations json ' + e.target.id + ' to ' + e.target.value);
//   console.log(e);
  return {
    type: 'CHANGE_FIELD_REFERENCE_RELATIONS_JSON',
    payload: {
      field: e.target.id,
      value: e.target.value
    }
  };
};

export const deleteFieldAuthorsReferenceJson = (e) => {
  console.log('action delete field authors json ' + e.target.id + ' to delete');
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'DELETE_FIELD_AUTHORS_REFERENCE_JSON',
    payload: {
      field: activeElement.id
    }
  };
};

export const changeFieldAuthorsReferenceJson = (e) => {
  console.log('action change field authors json ' + e.target.id + ' to ' + e.target.value + ' checked ' + e.target.checked);
  return {
    type: 'CHANGE_FIELD_AUTHORS_REFERENCE_JSON',
    payload: {
      field: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    }
  };
};

export const changeFieldDatePublishedRange = (datePublishedRange) => {
  console.log('action change field date published range ');
  console.log(datePublishedRange);
  return {
    type: 'CHANGE_FIELD_DATE_PUBLISHED_RANGE',
    payload: {
      field: 'datePublishedRange',
      value: datePublishedRange
    }
  };
}

export const getCuratorSourceId = async (mod) => {
  try {
    // GET /tag_source/{source_evidence_assertion}/{source_method}/{data_provider}/{secondary_data_provider_abbreviation}
    const res = await api.get('/tag_source/ATP:0000036/abc_literature_system/' + mod + '/' + mod);
    return res.data.tag_source_id;
  } catch (error) {
    if (error.response?.status === 404) {
      try {
        // POST /tag_source returns the full TagSourceSchemaShow
        // object on 201 — extract the id field, matching the GET above.
        const res = await api.post('/tag_source', {
          "source_evidence_assertion": "ATP:0000036",
          "source_method": "abc_literature_system",
          "validation_type": "professional_biocurator",
          "description": "Trained professional biocurator specializing in curation of model organism data using the ABC data entry form.",
          "secondary_data_provider_abbreviation": mod,
          "data_provider": mod,
          "created_by": "00u1mhf3mf28xjpPt5d7",
          "updated_by": "00u1mhf3mf28xjpPt5d7",
        });
        return res.data.tag_source_id;
      } catch (error) {
        return undefined;
      }
    }
  }
}

export const getXrefPatterns = (datatype) => { return dispatch => {
  const url = '/cross_reference/check/patterns/' + datatype;
  api.get(url)
    .then(res => {
      console.log(res);
      dispatch({
        type: 'UPDATE_XREF_PATTERNS',
        payload: { datatype: datatype, data: res.data }
      })
    })
    .catch(err =>
      console.log(err)
    );
} }

export const setBiblioUpdatingEntityAdd = (payload) => { return { type: 'SET_BIBLIO_UPDATING_ENTITY_ADD', payload: payload }; };

// export const updateButtonBiblioEntityAdd_NOTAXIOS = (updateArrayData) => dispatch => {
//   // console.log('in updateButtonBiblioEntityAdd action');
//   const [accessToken, subPath, payload, method, index, field, subField] = updateArrayData;
//   // const post_json = JSON.stringify(payload);
//   // console.log("payload " + post_json);
//   // console.log("payload " + payload);
//   // console.log("payload "); console.log(updateArrayData);
//   let newId = null;
//   const createUpdateButtonBiblioEntityAdd = async () => {
//     const url = restUrl + '/' + subPath;
//     console.log(url);
//     // console.log(notGithubVariables.authToken);
//     const res = await fetch(url, {
//       method: method,
//       mode: 'cors',
//       headers: {
//         'content-type': 'application/json',
//         'authorization': 'Bearer ' + accessToken
//       },
//       body: JSON.stringify( payload )
//     })
// 
//     let response_message = 'update success';
//     if ((method === 'DELETE') && (res.status === 204)) { }	// success of delete has no res.text so can't process like others
//     else {
//       const response_text = await res.text();
//       const response = JSON.parse(response_text);
//       if ( ((method === 'PATCH') && (res.status !== 202)) || 
//            ((method === 'DELETE') && (res.status !== 204)) || 
//            ((method === 'POST') && (res.status !== 201)) ) {
//         console.log('updateButtonBiblioEntityAdd action response not updated');
//         if (typeof(response.detail) !== 'object') {
//             response_message = response.detail; }
//           else if (typeof(response.detail[0].msg) !== 'object') {
//             response_message = 'error: ' + subPath + ' : ' + response.detail[0].msg + ': ' + response.detail[0].loc[1]; }
//           else {
//             response_message = 'error: ' + subPath + ' : API status code ' + res.status; }
//       }
//       if ((method === 'POST') && (res.status === 201)) {
//         newId = parseInt(response_text); }
//       // need dispatch because "Actions must be plain objects. Use custom middleware for async actions."
//       console.log('dispatch UPDATE_BUTTON_BIBLIO_ENTITY_ADD');
//     }
//     setTimeout(() => {
//       dispatch({
//         type: 'UPDATE_BUTTON_BIBLIO_ENTITY_ADD',
//         payload: {
//           responseMessage: response_message,
//           index: index,
//           value: newId,
//           field: field,
//           subField: subField
//         }
//       })
//     }, 500);
//   }
//   createUpdateButtonBiblioEntityAdd()
// };

export const setBiblioEntityRemoveEntity = (tetId, value) => ({
  type: 'SET_BIBLIO_ENTITY_REMOVE_ENTITY',
  payload: { tetId: tetId, value: value }
});

export const updateButtonBiblioEntityEditEntity = (accessToken, tetId, payload, method, dispatchAction) => { return dispatch => {
  // accessToken parameter kept for backwards compatibility - auth handled by API client interceptor
  const url = '/topic_entity_tag/' + tetId;
  let response_message = 'update success';

  api.request({
    url: url,
    method: method,
    data: payload
  })
    .then(res => {
      console.log(res);
      if (!isSuccess(res.status)) {
        response_message = 'error: ' + tetId + ' : API status code ' + res.status + ' for method ' + method; }
      dispatch({
        type: dispatchAction,
        payload: { tetId: tetId, responseMessage: response_message }
      })
    })
    .catch(err =>
      dispatch({
        type: dispatchAction,
        payload: { tetId: tetId, responseMessage: 'error: updateButtonBiblioEntityEditEntity failure on topic_entity_tag_id ' + tetId + ' ' + err }
      }));
} };

export const updateButtonBiblioEntityAdd = (updateArrayData, accessLevel) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // accessToken in updateArrayData kept for backwards compatibility - auth handled by API client interceptor
      const [, subPath, payload, method] = updateArrayData;
      const url = '/' + subPath;

      api.request({
        url: url,
        method: method,
        data: payload
      })
        .then(res => {
          let response_message;
          //console.log('API Response:', res);
          if (!isSuccess(res.status)) {
            response_message = 'error: ' + subPath + ' : API status code ' + res.status + ' for method ' + method;
            reject(new Error(response_message));
          } else {
            // response_message = `${JSON.stringify(res.data)}`;
            resolve(res.data);
            dispatch({
              type: 'UPDATE_BUTTON_BIBLIO_ENTITY_ADD',
              payload: { responseMessage: 'update success', accessLevel: accessLevel  }
            });
          }
        })
        .catch(err => {
          const errorMessage = 'error: ' + subPath + ' ' + err;
          console.error(errorMessage);
          dispatch({
            type: 'UPDATE_BUTTON_BIBLIO_ENTITY_ADD',
            payload: { responseMessage: errorMessage, accessLevel: accessLevel }
          });
          // Preserve axios response on the rejection so callers can read structured
          // error bodies (e.g. 409 conflict detail). See checkForExistingTags.
          const wrappedError = new Error(errorMessage);
          wrappedError.response = err.response;
          reject(wrappedError);
        });
    });
  };
};


async function fetchJsonData(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch data:', error);
    return null;
  }
};

export const sgd_entity_validation = (entityType, entityInputList, callback) => {

  const url = sgdApiBaseUrl + "entity/" + entityType + '/' + entityInputList.join('|').replace(/ /g, '+');
  fetchJsonData(url).then(data => {
    const searchMap = {};
    // console.log("data =" + JSON.stringify(data, null, 2));
    for (const entityResult of data) {
      // console.log("entityResult = " + JSON.stringify(entityResult, null, 2));
      searchMap[entityResult['query'].toLowerCase()] = entityResult['modEntityId'];
    }
    let entityResultList = [];
    for (const entity  of entityInputList) {
      const lowerEntity = entity.toLowerCase();
      if (lowerEntity in searchMap) {
        entityResultList.push({
          'entityTypeSymbol': entity,
          'curie': searchMap[lowerEntity]
        });
      } else {
        entityResultList.push({'entityTypeSymbol': entity, 'curie': 'no SGD curie'});
      }
    }
    if (callback) {
      callback(entityResultList); // Call the callback with the result list
    }
  }).catch(error => {
    console.error('Error fetching data:', error);
    if (callback) {
      callback([]); // Call the callback with an empty list in case of error
    }
  });

};


export const wb_entity_validation = (entityType, entityInputList, callback) => {
  let postData = {
    "datatype": entityType,
    "entities": entityInputList.join('|').replace(/ /g, '+')
  };
  // let postData = {"datatype":"gene","entities":"let-60|abc-1|WB:WBGeneQUACK|WB:WBGene99901234|WB:WBGene00001234|quack"};
  axios.post(wbApiBaseUrl, postData,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(res => {
      if (res.data) {
        const searchMap = {};
        for (const [curie, name] of Object.entries(res.data)) {
          searchMap[name.toLowerCase()] = curie;
          if (name.toLowerCase() === 'not found at wb') {
            searchMap[curie.toLowerCase()] = name; }
          else {
            searchMap[curie.toLowerCase()] = curie; }
        }
        let entityResultList = [];
        for (const entityTypeSymbol of entityInputList) {
          if (entityTypeSymbol.toLowerCase() in searchMap) {
            entityResultList.push({
              'entityTypeSymbol': entityTypeSymbol,
              'curie': searchMap[entityTypeSymbol.toLowerCase()]
            });
          } else {
            entityResultList.push({'entityTypeSymbol': entityTypeSymbol, 'curie': 'no WB curie'});
          }
        }
        if (callback) {
          callback(entityResultList); // Call the callback with the result list
        }
      }
    }).catch(error => {
    console.error('Error fetching data:', error);
    if (callback) {
      callback([]); // Call the callback with an empty list in case of error
    }
  });
};


export const abc_entity_validation = (entityType, entityInputList, taxon, callback) => {

  const entityListStr = entityInputList.join('|');
  const encodedEntityList = encodeURIComponent(entityListStr);
  const url = `/ontology/entity_validation/${taxon}/${entityType}/${encodedEntityList}`;
  api.get(url).then(res => {
    const data = res.data;
    const searchMap = {};
    const obsoleteMap = {};
    for (const entityResult of data) {
      if (entityResult['is_obsolete'] === false) {
        searchMap[entityResult['entity'].toLowerCase()] = entityResult['entity_curie'];
      } else {
        obsoleteMap[entityResult['entity'].toLowerCase()] = entityResult['entity_curie'];
      }
    }
    let entityResultList = [];
    for (const entity  of entityInputList) {
      const lowerEntity = entity.toLowerCase();
      if (lowerEntity in searchMap) {
        entityResultList.push({
          'entityTypeSymbol': entity,
          'curie': searchMap[lowerEntity]
        });
      } else if (lowerEntity in obsoleteMap) {
        entityResultList.push({'entityTypeSymbol': entity, 'curie': 'obsolete entity'});
      } else {
        entityResultList.push({'entityTypeSymbol': entity, 'curie': 'no mod curie'});
      }
    }
    if (callback) {
      callback(entityResultList); // Call the callback with the result list
    }
  }).catch(error => {
    console.error('Error fetching data:', error);
    if (callback) {
      callback([]); // Call the callback with an empty list in case of error
    }
  });

};

export const changeFieldEntityEntityList = (entityText, accessToken, entityIdValidation, taxon, entityType, callback) => {

  return async (dispatch) => {
    if (entityType.includes('allele')) {
      entityType = 'allele';
    }
    let entityInputList = [];
    if (entityText && entityText.trim() !== '') {
      entityInputList = entityText.split('\n').map(element => element.trim()).filter(item => item !== '');
    }

    if (entityIdValidation === 'sgd' && (entityType === 'complex' || entityType === 'pathway')) {
      return sgd_entity_validation(entityType, entityInputList, callback);
    }

    if (entityIdValidation === 'wb') {
      return wb_entity_validation(entityType, entityInputList, callback);
    }

    // Default case
    if (entityType.includes('construct')) {
      entityType = 'construct';
    }

    return abc_entity_validation(entityType, entityInputList, taxon, callback)

  };
};

export const setFieldEntityEditor = (id, value) => ({
  type: 'CHANGE_FIELD_ENTITY_EDITOR',
  payload: { field: id, value: value }
});

export const changeFieldEntityEditor = (e) => ({
  type: 'CHANGE_FIELD_ENTITY_EDITOR',
  payload: { field: e.target.id, value: e.target.value }
});

export const changeFieldEntityEditorPriority = (e) => ({
  type: 'CHANGE_FIELD_ENTITY_EDITOR_PRIORITY',
  payload: { field: e.target.id, value: e.target.value }
});

export const setTypeaheadName2CurieMap = (typeaheadName2CurieMap) => ({
  type: 'SET_TYPEAHEAD_NAME_2_CURIE_MAP',
  payload: typeaheadName2CurieMap
})

export const setEditTag = (editTag) => ({
  type: 'SET_EDIT_TAG',
  payload: editTag
});

export const setFilteredTags = (filteredTags) => ({
  type: 'SET_FILTERED_TAGS',
  payload: filteredTags
});

const getRevertButtonFromFontAwesomeElement = (activeElement) => {
  if (activeElement.nodeName === 'BUTTON') { return activeElement; }
  else if (activeElement.nodeName === 'svg') { return activeElement.parentNode; }
  else if (activeElement.nodeName === 'path') { return activeElement.parentNode.parentNode; }
  else { return activeElement; } }	// will probably error
export const biblioRevertField = (e) => {
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'BIBLIO_REVERT',
    payload: {
      field: activeElement.id,
      type: 'string'
    }
  };
};
export const biblioRevertFieldArray = (e) => {
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'BIBLIO_REVERT',
    payload: {
      field: activeElement.id,
      type: 'array'
    }
  };
};
export const biblioRevertAuthorArray = (e, initializeDict) => {
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'BIBLIO_REVERT',
    payload: {
      field: activeElement.id,
      initializeDict: initializeDict,
      type: 'author_array'
    }
  };
};
export const biblioRevertDatePublished = (e) => {
  const activeElement = getRevertButtonFromFontAwesomeElement(e.target);
  return {
    type: 'BIBLIO_REVERT_DATE_PUBLISHED',
    payload: {
      field: activeElement.id
    }
  };
};

export const biblioAddNewRowString = (e) => {
  return {
    type: 'BIBLIO_ADD_NEW_ROW',
    payload: {
      field: e.target.id,
      type: 'string',
      value: e.target.value
    }
  };
};
export const biblioAddNewAuthorAffiliation = (e) => {
  return {
    type: 'BIBLIO_ADD_NEW_AUTHOR_AFFILIATION',
    payload: {
      field: e.target.id,
      type: 'string',
      value: e.target.value
    }
  };
};
export const biblioAddNewRowDict = (e, initializeDict) => {
  console.log('action biblio add new row dict ' + e.target.id + ' to ' + e.target.value);
  console.log('action initializeDict ');
  console.log(initializeDict);
  return {
    type: 'BIBLIO_ADD_NEW_ROW',
    payload: {
      field: e.target.id,
      initializeDict: initializeDict,
      type: 'dict',
      value: e.target.value
    }
  };
};

export function generateRelationsSimple(referenceJson) {
  let comcorMapping = {}
  comcorMapping['CommentOn'] = 'HasComment'
  comcorMapping['ErratumFor'] = 'HasErratum'
  comcorMapping['ExpressionOfConcernFor'] = 'HasExpressionOfConcernFor'
  comcorMapping['ReprintOf'] = 'HasReprint'
  comcorMapping['RepublishedFrom'] = 'RepublishedIn'
  comcorMapping['RetractionOf'] = 'HasRetraction'
  comcorMapping['UpdateOf'] = 'HasUpdate'
  comcorMapping['ChapterIn'] = 'hasChapter'
  const comcorDirections = ['to_references', 'from_references']
  referenceJson['relations'] = []
  for (const direction of comcorDirections) {
    for (const comcorDict of referenceJson['reference_relations'][direction].values()) {
      let curieFieldInDict = (direction === 'to_references') ? 'reference_curie_to' : 'reference_curie_from';
      let curie = comcorDict[curieFieldInDict]
      let dbid = comcorDict['reference_relation_id']
      let type = comcorDict['reference_relation_type']
      //if (type === 'hasChapter' || type === 'ChapterIn'){continue }
      if (direction === 'from_references') {
        if (type in comcorMapping) { type = comcorMapping[type] } }
      let newComcorDict = {}
      newComcorDict['reference_relation_id'] = dbid
      newComcorDict['type'] = type
      newComcorDict['curie'] = curie
      referenceJson['relations'].push(newComcorDict)
    } }
}

// Module-level request deduplication for mod reference types
let pendingModRefTypesRequest = null;

export const fetchModReferenceTypes = (mods) => {
  return (dispatch, getState) => {
    // Check if already in Redux
    const { modReferenceTypes } = getState().biblio;
    if (modReferenceTypes && Object.keys(modReferenceTypes).length > 0) {
      return Promise.resolve(modReferenceTypes);
    }

    // Return pending request if one exists (deduplication)
    if (pendingModRefTypesRequest) {
      return pendingModRefTypesRequest;
    }

    // Create new request
    pendingModRefTypesRequest = (async () => {
      try {
        const baseUrl = '/reference/mod_reference_type/by_mod/';
        let result = {};
        for (const mod of mods) {
          if (mod !== '') {
            const response = await api.get(baseUrl + mod);
            result[mod] = response.data;
            result[mod].unshift('');
          }
        }
        dispatch({ type: 'SET_MOD_REFERENCE_TYPES', payload: result });
        return result;
      } catch (error) {
        console.error('Error fetching mod reference types:', error);
        return {};
      } finally {
        pendingModRefTypesRequest = null;
      }
    })();

    return pendingModRefTypesRequest;
  };
};


export const getDescendantATPIds = async (atpID) => {

  const url = `/ontology/search_descendants/${encodeURIComponent(atpID)}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error occurred in getDescendantATPIds:", error);
    throw error;
  }
};

export const fetchDisplayTagData = async () => {
  // Fallback if the endpoint returns nothing or fails:
  const fallbackDisplayTagData = [
    { curie: "ATP:0000147", name: "primary display" },
    { curie: "ATP:0000148", name: "OMICs display" },
    { curie: "ATP:0000132", name: "additional display" },
    { curie: "ATP:0000130", name: "review display" },
  ];

  const url = `/ontology/search_descendants/ATP:0000136`;

  try {
    const response = await api.get(url);

    // If response.data is a non-empty array, return it; otherwise fallback
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data;
    } else {
      return fallbackDisplayTagData;
    }
  } catch (error) {
    console.error("Error occurred:", error);
    return fallbackDisplayTagData;
  }
};

export const fetchDataContextData = async () => {
  // SCRUM-5697. data_context is a hierarchy under ATP:0000323 "data context":
  //   ATP:0000324 mentioned data -> ATP:0000360 background information
  //                                 ATP:0000325 experimentally studied data
  //   ATP:0000326 marker data    -> ATP:0000328 expression marker
  //                                 ATP:0000327 genetic marker
  //
  // Curators pick a LEAF only: the two groupings are organisational, not
  // curation choices. Rather than hardcode which curies are groupings, we take
  // all descendants and subtract the root's direct children -- those are exactly
  // the intermediate nodes. So renaming or adding a grouping needs no UI change.
  //
  // Note the /<direct_children_only>/<include_self>/<include_names> path form is
  // required: the short /search_descendants/<curie> form returns bare curie
  // strings, not {curie, name} objects.
  const fallbackDataContextData = [
    { curie: "ATP:0000360", name: "background information" },
    { curie: "ATP:0000325", name: "experimentally studied data" },
    { curie: "ATP:0000328", name: "expression marker" },
    { curie: "ATP:0000327", name: "genetic marker" },
  ];

  const allUrl = `/ontology/search_descendants/ATP:0000323/false/false/true`;
  const groupingsUrl = `/ontology/search_descendants/ATP:0000323/true/false/true`;

  try {
    const [allRes, groupingsRes] = await Promise.all([
      api.get(allUrl),
      api.get(groupingsUrl),
    ]);

    const all = Array.isArray(allRes.data) ? allRes.data : [];
    const groupings = Array.isArray(groupingsRes.data) ? groupingsRes.data : [];
    if (all.length === 0) {
      return fallbackDataContextData;
    }

    const groupingCuries = new Set(groupings.map((t) => t.curie));
    const leaves = all.filter((t) => t && t.curie && !groupingCuries.has(t.curie));
    // If the shape ever changes such that everything is filtered out, prefer the
    // known-good list over an empty dropdown.
    return leaves.length > 0 ? leaves : fallbackDataContextData;
  } catch (error) {
    console.error("Error occurred in fetchDataContextData:", error);
    return fallbackDataContextData;
  }
};

export const biblioQueryReferenceCurie = (referenceCurie) => dispatch => {
  console.log('action in biblioQueryReferenceCurie action');
  const createBiblioQueryReferenceCurie = async () => {
    const url = '/reference/' + referenceCurie;
    try {
      const res = await api.get(url);
      const response = res.data;
      let response_payload = { detail: 'Reference not found' };
      if (response !== undefined) {
        const referenceJson = response;
        if ('reference_relations' in referenceJson && referenceJson['reference_relations'] !== null) {
          generateRelationsSimple(referenceJson);
        }
        response_payload = referenceJson;
      }
      // need dispatch because "Actions must be plain objects. Use custom middleware for async actions."
      dispatch({
        type: 'BIBLIO_GET_REFERENCE_CURIE',
        payload: response_payload
      })
    } catch (error) {
      dispatch({
        type: 'BIBLIO_GET_REFERENCE_CURIE',
        payload: { detail: 'Reference not found' }
      })
    }
  }
  createBiblioQueryReferenceCurie()
};

export const closeBiblioUpdateAlert = () => {
  console.log("action closeBiblioUpdateAlert");
  return {
    type: 'CLOSE_BIBLIO_UPDATE_ALERT'
  };
};

export const changeBiblioMeshExpandToggler = (e) => {
  console.log('action change biblio mesh expand toggler radio ' + e.target.id + ' to ' + e.target.value);
  let biblioMeshExpandTogglerSelected = 'short';
  if (e.target.id === 'biblio-mesh-expand-toggler-detailed') { biblioMeshExpandTogglerSelected = 'detailed'; }
  return {
    type: 'CHANGE_BIBLIO_MESH_EXPAND_TOGGLER',
    payload: biblioMeshExpandTogglerSelected
  };
};

export const changeBiblioAuthorExpandToggler = (e) => {
  console.log('action change biblio author expand toggler radio ' + e.target.id + ' to ' + e.target.value);
  let biblioAuthorExpandTogglerSelected = 'first';
  if (e.target.id === 'biblio-author-expand-toggler-list') { biblioAuthorExpandTogglerSelected = 'list'; }
  else if (e.target.id === 'biblio-author-expand-toggler-detailed') { biblioAuthorExpandTogglerSelected = 'detailed'; }
  return {
    type: 'CHANGE_BIBLIO_AUTHOR_EXPAND_TOGGLER',
    payload: biblioAuthorExpandTogglerSelected
  };
};

export const changeBiblioSupplementExpandToggler = (e) => {
  console.log('action change biblio supplement expand toggler radio ' + e.target.id + ' to ' + e.target.value);
  let biblioSupplementExpandTogglerSelected = 'tarball';
  if (e.target.id === 'biblio-supplement-expand-toggler-list') { biblioSupplementExpandTogglerSelected = 'list'; }
  else if (e.target.id === 'biblio-supplement-expand-toggler-detailed') { biblioSupplementExpandTogglerSelected = 'detailed'; }
  return {
    type: 'CHANGE_BIBLIO_SUPPLEMENT_EXPAND_TOGGLER',
    payload: biblioSupplementExpandTogglerSelected
  };
};

export const openBiblioAuthorReorder = () => {
  return {
    type: 'BIBLIO_AUTHOR_REORDER_OPEN'
  };
};

export const closeBiblioAuthorReorder = () => {
  return {
    type: 'BIBLIO_AUTHOR_REORDER_CLOSE'
  };
};

export const setBiblioAuthorReorderFullScreen = (fullScreen) => {
  return {
    type: 'BIBLIO_AUTHOR_REORDER_FULL_SCREEN',
    payload: fullScreen
  };
};

export const changeBiblioActionToggler = (e, biblioActionTogglerSelected) => {
  console.log('action change biblio action toggler radio ' + e.target.id + ' to ' + biblioActionTogglerSelected);
  return {
    type: 'CHANGE_BIBLIO_ACTION_TOGGLER',
    payload: biblioActionTogglerSelected
  };
};

export const setBiblioAction = (biblioAction) => {
  console.log("action setBiblioAction");
  return {
    type: 'SET_BIBLIO_ACTION',
    payload: biblioAction
  };
};

// citation now updates from database triggers
// export const setUpdateCitationFlag = (updateCitationFlag) => {
//   console.log("action setUpdateCitationFlag");
//   return {
//     type: 'SET_UPDATE_CITATION_FLAG',
//     payload: updateCitationFlag
//   };
// };

export const setUpdateBiblioFlag = (updateBiblioFlag) => {
  console.log("action setUpdateBiblioFlag");
  return {
    type: 'SET_UPDATE_BIBLIO_FLAG',
    payload: updateBiblioFlag
  };
};

export const validateFormUpdateBiblio = () => {
  console.log("action validateFormUpdateBiblio");
  return {
    type: 'VALIDATE_FORM_UPDATE_BIBLIO'
  };
};


export const updateButtonBiblio = (updateArrayData) => dispatch => {
  // accessToken in updateArrayData kept for backwards compatibility - auth handled by API client interceptor
  const [, subPath, payload, method, index, field, subField] = updateArrayData;
  let newId = null;

  const createUpdateButtonBiblio = async () => {
    const url = '/' + subPath;
    console.log(url);

    try {
      const res = await api.request({
        url: url,
        method: method,
        data: payload
      });

      let response_message = 'update success';
      if ((method === 'DELETE') && (res.status === 204)) {
        // success of delete has no response body
      } else {
        const response = res.data;
        if (!isSuccess(res.status)) {
          console.log('updateButtonBiblio action response not updated');
          if (typeof(response.detail) !== 'object') {
            response_message = response.detail;
          } else if (typeof(response.detail[0].msg) !== 'object') {
            response_message = 'error: ' + subPath + ' : ' + response.detail[0].msg + ': ' + response.detail[0].loc[1];
          } else {
            response_message = 'error: ' + subPath + ' : API status code ' + res.status;
          }
        }
        if (method === 'POST' && isSuccess(res.status)) {
          newId = response?.[subField] ?? null;
        }
        console.log('dispatch UPDATE_BUTTON_BIBLIO');
      }

      setTimeout(() => {
        dispatch({
          type: 'UPDATE_BUTTON_BIBLIO',
          payload: {
            responseMessage: response_message,
            index: index,
            value: newId,
            field: field,
            subField: subField
          }
        });
      }, 500);
    } catch (error) {
      console.error('updateButtonBiblio error:', error);
      const response_message = error.response?.data?.detail || 'error: ' + subPath + ' : ' + error.message;
      setTimeout(() => {
        dispatch({
          type: 'UPDATE_BUTTON_BIBLIO',
          payload: {
            responseMessage: response_message,
            index: index,
            value: null,
            field: field,
            subField: subField
          }
        });
      }, 500);
    }
  };
  createUpdateButtonBiblio();
};

export const resetBiblioIsLoading = () => {
  return {
    type: 'RESET_BIBLIO_IS_LOADING'
  };
};


export const setEntityModalText = (payload) => {
  return {
    type: 'SET_ENTITY_MODAL_TEXT',
    payload: payload
  };
};

export const setReferenceFiles = (payload) => {
  return {
    type: 'SET_REFERENCE_FILES',
    payload: payload
  };
};

// Module-level cache to prevent concurrent duplicate fetches
let pendingReferenceFilesRequest = null;
let pendingReferenceFilesCurie = null;

export const fetchReferenceFiles = (referenceCurie, forceRefresh = false) => {
  return (dispatch, getState) => {
    const { referenceFiles, referenceCurie: storedCurie } = getState().biblio;

    // If data exists for this reference and not forcing refresh, don't fetch again
    if (!forceRefresh && referenceFiles.length > 0 && storedCurie === referenceCurie) {
      return Promise.resolve(referenceFiles);
    }

    // If already fetching the SAME curie, return the pending promise
    if (pendingReferenceFilesRequest && pendingReferenceFilesCurie === referenceCurie) {
      return pendingReferenceFilesRequest;
    }

    dispatch({ type: 'SET_REFERENCE_FILES_LOADING', payload: true });

    // Track which curie we're fetching
    pendingReferenceFilesCurie = referenceCurie;

    pendingReferenceFilesRequest = (async () => {
      try {
        const response = await api.get("/reference/referencefile/show_all/" + referenceCurie);
        // Only dispatch if this is still the curie we want
        const currentCurie = getState().biblio.referenceCurie;
        if (currentCurie === referenceCurie) {
          dispatch(setReferenceFiles(response.data));
          return response.data;
        }
        // Curie changed while fetching - don't dispatch stale data
        return [];
      } catch (error) {
        console.error('Error fetching reference files:', error);
        dispatch({ type: 'SET_REFERENCE_FILES_LOADING', payload: false });
        return [];
      } finally {
        // Only clear if this request is still the active one
        if (pendingReferenceFilesCurie === referenceCurie) {
          pendingReferenceFilesRequest = null;
          pendingReferenceFilesCurie = null;
        }
      }
    })();

    return pendingReferenceFilesRequest;
  };
};

export const setTopicEntityTags = (tags, referenceCurie) => {
  return {
    type: 'SET_TOPIC_ENTITY_TAGS',
    payload: { tags, referenceCurie }
  };
};

// Module-level cache to prevent concurrent duplicate fetches
let pendingTopicEntityTagsRequest = null;
let pendingTopicEntityTagsCurie = null;

// One page is fetched; bulk-loaded papers (e.g. the ZFIN large-scale loads,
// SCRUM-6614) can exceed this, so the fetch also asks for the true total and
// sorts by source_method — curated sources like abc_literature_system sort
// before the *_reference_curation bulk loads, so anything truncated is
// bulk-loaded rows, never curator-entered tags.
const TET_FETCH_PAGE_SIZE = 8000;

// Load all topic entity tags for a reference into the redux store so that any
// reference-based (Biblio) page can reuse them (e.g. the entity counts summary)
// without each component issuing its own request.
export const fetchTopicEntityTags = (referenceCurie, forceRefresh = false) => {
  return (dispatch, getState) => {
    if (!referenceCurie) {
      return Promise.resolve([]);
    }

    const { topicEntityTags, topicEntityTagsCurie } = getState().biblio;

    // If data already loaded for this reference and not forcing a refresh, reuse it
    if (!forceRefresh && topicEntityTagsCurie === referenceCurie) {
      return Promise.resolve(topicEntityTags);
    }

    // If already fetching the SAME curie, return the pending promise — but not
    // when forcing a refresh, so a post-edit forceRefresh never resolves to an
    // older in-flight (non-forced) fetch that predates the edit.
    if (!forceRefresh && pendingTopicEntityTagsRequest && pendingTopicEntityTagsCurie === referenceCurie) {
      return pendingTopicEntityTagsRequest;
    }

    dispatch({ type: 'SET_TOPIC_ENTITY_TAGS_LOADING', payload: true });

    pendingTopicEntityTagsCurie = referenceCurie;

    pendingTopicEntityTagsRequest = (async () => {
      try {
        const baseUrl = '/topic_entity_tag/by_reference/' + referenceCurie;
        // The source_method sort keeps curated tags inside the page cap. The
        // TET table pages server-side (SCRUM-6618) and the entity counts and
        // curator-validation gating are server-computed (SCRUM-6620) — this
        // fetch now feeds only the setAll* filter lists, QuickTopicAddition,
        // and the older-backend fallbacks in the Actions cell and
        // EntityCountsByMod. Removing it is SCRUM-6620's last step.
        const url = baseUrl + '?page=1&page_size=' + TET_FETCH_PAGE_SIZE + '&sort_by=source_method';
        const response = await api.get(url);
        const tags = response.data || [];
        // Only dispatch if this is still the curie we want
        if (getState().biblio.referenceCurie === referenceCurie) {
          dispatch(setTopicEntityTags(tags, referenceCurie));
        }
        return tags;
      } catch (error) {
        console.error('Error fetching topic_entity_tag by_reference:', error);
        dispatch({ type: 'SET_TOPIC_ENTITY_TAGS_LOADING', payload: false });
        return [];
      } finally {
        if (pendingTopicEntityTagsCurie === referenceCurie) {
          pendingTopicEntityTagsRequest = null;
          pendingTopicEntityTagsCurie = null;
        }
      }
    })();

    return pendingTopicEntityTagsRequest;
  };
};

export const setBiblioEditorModalText = (payload) => {
  return {
    type: 'SET_BIBLIO_EDITOR_MODAL_TEXT',
    payload: payload
  };
};

export const setBiblioUpdating = (payload) => {
  return {
    type: 'SET_BIBLIO_UPDATING',
    payload: payload
  };
};

export const setReferenceCurie = (reference_curie) => {
  console.log("action setReferenceCurie");
  return {
    type: 'SET_REFERENCE_CURIE',
    payload: reference_curie
  };
};

export const setGetReferenceCurieFlag = (true_false) => {
  console.log("action setReferenceCurie");
  return {
    type: 'SET_GET_REFERENCE_CURIE_FLAG',
    payload: true_false
  };
};

export const addLoadingFileName = (fileName) => {
  return {
    type: 'ADD_LOADING_FILE_NAME',
    payload: fileName
  }
}

export const removeLoadingFileName = (fileName) => {
  return {
    type: 'REMOVE_LOADING_FILE_NAME',
    payload: fileName
  }
}

export const downloadPDFfile = (referencefileId, filename, accessToken, referenceId) => {
  // accessToken parameter kept for backwards compatibility - auth handled by API client interceptor
  return dispatch => {
    dispatch(addLoadingFileName(filename));
    const url = '/reference/referencefile/download_file/' + referencefileId;

    api.get(url, {
      responseType: 'blob' // important for handling binary data
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
    }).finally(() => {
      dispatch(removeLoadingFileName(filename));
    });
  };
}

export const downloadReferencefile = (referencefileId, filename, accessToken, referenceId) => {
  // accessToken parameter kept for backwards compatibility - auth handled by API client interceptor
  if (filename.endsWith('.pdf')) {
    return downloadPDFfile(referencefileId, filename, accessToken, referenceId);
  }

  return dispatch => {
    dispatch(addLoadingFileName(filename));
    let url;
    if (referenceId !== undefined) {
      url = '/reference/referencefile/additional_files_tarball/' + referenceId;
    } else {
      url = '/reference/referencefile/download_file/' + referencefileId;
    }
    api.get(url, {
      responseType: "blob" // important
    }).then(response => {
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    }).finally(() => {
      dispatch(removeLoadingFileName(filename));
    });
  };
}

export const setFileUploadingCount = (payload) => { return { type: 'SET_FILE_UPLOADING_COUNT', payload: payload }; };

export const fileUploadResult = (filename, resultMessage) => {
  return {
    type: 'FILE_UPLOAD_RESULT',
    payload: {
      filename: filename,
      resultMessage: resultMessage
    }
  }; };

export const setFileUploadingShowSuccess = (payload) => {
  return {
    type: 'SET_FILE_UPLOADING_SHOW_SUCCESS',
    payload: payload
  };
};

export const setFileUploadingShowModal = (payload) => {
  return {
    type: 'SET_FILE_UPLOADING_SHOW_MODAL',
    payload: payload
  };
};

export const setFileUploadingModalText = (modalText) => ({
  type: 'SET_FILE_UPLOADING_MODAL_TEXT',
  payload: modalText
})

export const setAllSpecies = (allSpecies) => ({
  type: 'SET_ALL_SPECIES',
  payload: allSpecies
});

export const setAllEntities = (allEntities) => ({
  type: 'SET_ALL_ENTITIES',
  payload: allEntities
});

export const setAllTopics = (allTopics) => ({
  type: 'SET_ALL_TOPICS',
  payload: allTopics
});

export const setAllEntityTypes = (allEntityTypes) => ({
  type: 'SET_ALL_ENTITY_TYPES',
  payload: allEntityTypes
});

export const setTopicEntitySourceId = (topicEntitySourceId) => ({
  type: 'SET_TOPIC_ENTITY_SOURCE_ID',
  payload: topicEntitySourceId
});

// Module-level cache to prevent concurrent duplicate fetches
let pendingTaxonRequest = null;

export const fetchTaxonData = () => {
  return (dispatch, getState) => {
    // Check if data already exists in Redux store
    const { modToTaxon, curieToNameTaxon } = getState().biblio;

    // If data exists, don't fetch again
    if (modToTaxon && curieToNameTaxon) {
      return Promise.resolve({ modToTaxon, curieToNameTaxon });
    }

    // If already fetching, return the pending promise
    if (pendingTaxonRequest) {
      return pendingTaxonRequest;
    }
    // CRITICAL: Create and assign promise IMMEDIATELY after check, before ANY other code
    // This minimizes the race condition window
    pendingTaxonRequest = new Promise((resolve, reject) => {
      // Dispatch START action inside executor
      dispatch({ type: 'FETCH_TAXON_DATA_START' });

      getTaxonData()
        .then(({ modToTaxon, curieToName }) => {
          // Enhance curieToName with WB extension
          const enhancedCurieToName = { ...curieToName, "use_wb": "other nematode" };

          dispatch({
            type: 'FETCH_TAXON_DATA_SUCCESS',
            payload: {
              modToTaxon,
              curieToNameTaxon: enhancedCurieToName
            }
          });

          resolve({ modToTaxon, curieToNameTaxon: enhancedCurieToName });
        })
        .catch(error => {
          dispatch({
            type: 'FETCH_TAXON_DATA_ERROR',
            payload: { error: error.message }
          });
          reject(error);
        })
        .finally(() => {
          // Clear pending request after completion
          pendingTaxonRequest = null;
        });
    });

    return pendingTaxonRequest;
  };
};

export const clearTaxonData = () => {
  // Also clear pending request when clearing data
  pendingTaxonRequest = null;
  return {
    type: 'CLEAR_TAXON_DATA'
  };
};
